export default __webpack_public_path__ + "static/media/jp.415cd913.svg";